module.exports = __webpack_public_path__ + "img/service-big-01.b0024844.jpg";